import { apiClient } from '@/shared/api/http-client';

import type {
    GenerateSessionNoteInput,
    GenerateSessionNoteOutput,
    SessionNote,
    SetSessionNoteFeedbackInput,
    UpdateSessionNoteInput,
    UpdateSessionNoteOutput,
    WriteSessionNoteInput,
} from '../model/session-note.types';

export const sessionNotesApi = {
    write: async (data: WriteSessionNoteInput, signal?: AbortSignal): Promise<SessionNote> => {
        return apiClient.post<SessionNote>('/session-notes/write', data, signal);
    },

    update: async (
        data: UpdateSessionNoteInput,
        signal?: AbortSignal,
    ): Promise<UpdateSessionNoteOutput> => {
        const { id, ...body } = data;
        return apiClient.patch<UpdateSessionNoteOutput>(`/session-notes/${id}`, body, signal);
    },

    generate: async (
        data: GenerateSessionNoteInput,
        signal?: AbortSignal,
    ): Promise<GenerateSessionNoteOutput> => {
        return apiClient.post<GenerateSessionNoteOutput>(`/session-notes/generate`, data, signal);
    },

    delete: async (id: string, signal?: AbortSignal): Promise<void> => {
        return apiClient.delete<void>(`/session-notes/${id}`, signal);
    },

    setFeedback: async (data: SetSessionNoteFeedbackInput, signal?: AbortSignal): Promise<void> => {
        const { id, ...body } = data;
        return apiClient.post<void>(`/session-notes/${id}/set-feedback`, body, signal);
    },
};
